import React from 'react';

import Chip from 'components/Chip';

import { getBandColor, getRiskBand } from './bands';
import { LIKELIHOOD_LEVELS, SEVERITY_LEVELS } from './constants';
import { isRated, RiskMatrixDisplayProps } from './types';

// The read view: the score, banded by colour. Dense form is the register's grid cell.
const RiskMatrixDisplay = ({ value, dense = false }: RiskMatrixDisplayProps): React.ReactElement | null => {
  if (!isRated(value)) {
    return null;
  }

  const { likelihood, severity, score } = value;
  const band = getRiskBand(severity, likelihood, SEVERITY_LEVELS, LIKELIHOOD_LEVELS);
  const { bg, color } = getBandColor(band);

  return (
    <Chip
      id="risk-matrix-value"
      data-testid="risk-matrix-value"
      size={dense ? 'small' : 'medium'}
      label={`${score} ${band}`}
      capitalizeLabel={false}
      colors={{ background: bg, foreground: color, border: bg }}
      tooltipTitle={`Likelihood ${likelihood}, severity ${severity}`}
    />
  );
};

export default RiskMatrixDisplay;
